import { useQuery } from '@tanstack/react-query'
import { fetchUserDetails } from '../repository/misc'

export const useUserDetails = () => {
  const {
    data: userDetails,
    isLoading,
    error
  } = useQuery({
    queryKey: ['userDetails'],
    queryFn: fetchUserDetails,
    retry: 3
  })

  return { userDetails: userDetails, isLoading, error }
}
